import Constants from '@/Constants';
import { ImportStatus } from '@/models/EnrollmentProcess';
import { Person } from '@/models/Person';
import { getDisplayName } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import React, { Dispatch, SetStateAction } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';

interface Props {
    itemsCount?: number;
    errorsUri: string;
    status?: string;
    page: number;
    setPage: Dispatch<SetStateAction<number>>;
    limit: number;
    setLimit: Dispatch<SetStateAction<number>>;
    success: boolean;
    setSuccess: Dispatch<SetStateAction<boolean>>;
    error: boolean;
    setError: Dispatch<SetStateAction<boolean>>;
    search: string;
    setSearch: Dispatch<SetStateAction<string>>;
    person?: Person;
}

const PAGINATION_LIMITS = [50, 30, 20, 10];

export function Header({
    itemsCount = 0,
    errorsUri,
    status,
    page,
    setPage,
    limit,
    setLimit,
    success,
    setSuccess,
    error,
    setError,
    search,
    setSearch,
    person,
}: Props) {
    const strings = useSelector((state: ApplicationState) => state.locale.data);

    return (
        <>
            <div className="modal-top-content">
                {person && (
                    <div className="name-email-container">
                        <span className="span-label">{strings.ENROLL}</span>
                        <span className="span-name">{getDisplayName(person)}</span>
                        <span className="span-email">{person.email}</span>
                    </div>
                )}
                {itemsCount > 0 && (
                    <>
                        <div className="pagination-container">
                            <span className="span-page">{strings.CURRENT_PAGE}</span>
                            <Pagination
                                activePage={page}
                                itemClass="page-item"
                                itemsCountPerPage={limit}
                                linkClass="page-link"
                                nextPageText={
                                    <i className="material-icons align-middle" style={{ fontSize: 14 }}>
                                        chevron_right
                                    </i>
                                }
                                onChange={(val) => setPage(val)}
                                pageRangeDisplayed={5}
                                prevPageText={
                                    <i className="material-icons align-middle" style={{ fontSize: 14 }}>
                                        chevron_left
                                    </i>
                                }
                                totalItemsCount={itemsCount}
                            />
                        </div>
                        <div className="pagination-container">
                            <span className="span-page">{strings.ITEMS_PER_PAGE}</span>
                            <div className="dropdown">
                                <button className="btn btn-primary btn-sm" data-toggle="dropdown">
                                    {limit}
                                    <i className="material-icons align-middle">arrow_drop_down</i>
                                </button>
                                <div aria-labelledby="dropdownMenuButton" className="dropdown-menu">
                                    {PAGINATION_LIMITS.map((item) => (
                                        <span className="dropdown-item" key={item} onClick={() => setLimit(item)}>
                                            {item}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className="top-search-content modal-error-search">
                {status !== ImportStatus.COMPLETED && (
                    <>
                        <button
                            className="btn btn-primary btn-sm new-item-button status-button"
                            data-toggle="dropdown"
                            onClick={() => {}}
                            type="button"
                        >
                            {strings.STATUS}
                        </button>
                        <div className="dropdown-menu dropdown-menu-right drop-three">
                            <div className="triangle-container t-three">
                                <div className="dropdown-triangle" />
                                <div className="dropdown-triangle-border" />
                            </div>
                            <div className="dropdown-content" onClick={() => setSuccess((ps) => !ps)} onKeyDown={() => {}} role="button" tabIndex={0}>
                                <i className="material-icons va-t m-right--xxs">
                                    {success ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                </i>
                                <span>{strings.SUCCESS}</span>
                            </div>
                            <div className="dropdown-content" onClick={() => setError((ps) => !ps)} onKeyDown={() => {}} role="button" tabIndex={0}>
                                <i className="material-icons va-t m-right--xxs">
                                    {error ? Constants.icons.CHECK_BOX : Constants.icons.CHECK_BOX_OUTLINE_BLANK}
                                </i>
                                <span>{strings.ERROR}</span>
                            </div>
                        </div>
                    </>
                )}
                <div className="form-group inner-addon left-addon modal-error-search-input">
                    <div>
                        <i className="material-icons-outlined align-middle input-icon">search</i>
                        <input
                            className="form-control"
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder={strings.SEARCH}
                            type="search"
                            value={search}
                        />
                    </div>
                </div>
                <a
                    className="btn btn-primary btn-sm new-item-button download-button"
                    href={errorsUri}
                    style={{ visibility: status === ImportStatus.COMPLETED ? 'hidden' : 'visible' }}
                >
                    {strings.DOWNLOAD_ERRORS}
                </a>
            </div>
        </>
    );
}
